import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { useFacility } from "@/lib/facility/facility";
import { orpc } from "@/lib/orpc";

export const Route = createFileRoute(
  "/_authenticated/_administration/settings/facilities/$facilityId",
)({
  component: OpenFacility,
});

/** A building's own address, for links from Aria and a person's access: it puts the building in
 * view and opens its profile, so a building's settings are only ever read under the Facility tab.
 * An inactive or unknown building has no profile to open and lands back on the list. */
function OpenFacility() {
  const { facilityId } = Route.useParams();
  const { setFacilityId } = useFacility();
  const navigate = useNavigate();
  const facility = useQuery(
    orpc.administration.facilities.get.queryOptions({ input: { facilityId } }),
  );
  const active = facility.data?.status === "active";
  const settled = facility.isSuccess || facility.isError;

  useEffect(() => {
    if (!settled) return;
    if (active) setFacilityId(facilityId);
    void navigate({ to: active ? "/settings/facility" : "/settings/facilities", replace: true });
  }, [active, facilityId, navigate, setFacilityId, settled]);

  return <Skeleton className="h-48" />;
}
